import styled from "styled-components";

export const StyledAlert = styled.div`
  position: absolute;
  top: 100px;
  right: 40px;
  min-width: 200px;
  z-index: 10000;
`;